export default __webpack_public_path__ + "static/media/linkedin.eaa2dcde.svg";